import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { connectState, InputObservable } from '@y42/angular/util';
import { OrchestrationQuery } from '@y42/orchestration';
import { map, Observable, of, switchMap } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'y42-orchestration-name',
  templateUrl: './orchestration-name.component.html',
  styleUrls: ['./orchestration-name.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrchestrationNameComponent {
  constructor(private readonly orchestrationQuery: OrchestrationQuery) {}

  @Input()
  @InputObservable()
  path?: string;
  private readonly path$!: Observable<string | undefined>;

  readonly state = connectState(this, {
    isUnknown: this.path$.pipe(map((path) => path === undefined)),
    orchestrationData: this.path$.pipe(
      switchMap((path) => {
        if (!path) {
          return of(null);
        }
        return this.orchestrationQuery.selectEntity(path).pipe(
          map((orchestration) => {
            return orchestration
              ? { path, isDeleted: false, name: orchestration.name }
              : { path, isDeleted: true, name: '' };
          }),
        );
      }),
    ),
  });
}
